<template>
  <div>
    <div class="container is-fluid" v-if="galleriesById[galleryId] && !galleriesById[galleryId].passwordNeeded">
      <div class="columns">
        <div class="column">
          <div class="title-with-button">
            <div class="title-col">
              <h1 class="title" v-if="!galleriesById[galleryId]">Gallery {{galleryId}}</h1>
              <h1 class="title" v-if="galleriesById[galleryId]">{{name}}</h1>
            </div>
            <div class="button-col">
              <a v-bind:href="'/api/galleries/' + galleryId" class="icon-only-button">
                <i class="im im-download" style="margin-top: 6px;"></i>
              </a>
            </div>
          </div>
          <div class="columns is-multiline" v-if="galleriesById[galleryId]">
            <div
              class="column is-3"
              v-for="imageId in galleriesById[galleryId].imageIds"
              :key="imageId"
            >
              <ImageCard v-bind:imageId="imageId" />
            </div>
          </div>
        </div>
        <div class="column is-2" v-if="false">
          <div class="columns">
            <div class="column">
              <button class="icon-only-button" v-on:click="() => this.showConfig = false">
                <i class="im im-arrow-right" style="margin-top: 6px;"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="login" v-if="galleriesById[galleryId] && galleriesById[galleryId].passwordNeeded">
      <div class="box">
        <h2 class="title is-4">Enter Credentials</h2>
        <div class="field">
          <label class="label">Password</label>
          <input class="input" type="password" v-model="password" v-on:keyup.enter="getTokenForGallery" />
        </div>
        <div class="notification is-danger" v-if="errorMessage">{{errorMessage}}</div>
        <button class="button is-pulled-right is-primary" v-on:click="getTokenForGallery">Send</button>
      </div>
    </div>
  </div>
</template>

<script>
import ImageCard from "../components/ImageCard.vue";
import { mapState, mapActions } from "vuex";

export default {
  components: {
    ImageCard
  },
  data() {
    return {
      galleryId: 0,
      showConfig: false,
      password: ""
    };
  },
  computed: {
    ...mapState("public", ["galleriesById", "tokensById", "errorMessage"])
  },
  created() {
    this.galleryId = parseInt(this.$route.params.id);
    if (!this.galleriesById[this.galleryId]) {
      console.log("getting gallery")
      this.getGallery(this.galleryId);
    }
  },
  watch: {
    $route: {
      handler: function(to, from) {
        console.log("gallery with id", to);
      }
    }
  },
  methods: {
    getTokenForGallery() {
      console.log("logging in...")
      this.loginForGallery({id: this.galleryId, password: this.password});
    },
    ...mapActions("public", ["getGallery", "loginForGallery"])
  }
};
</script>